<template>
  <div  class="o-hidden pos-relative t-center flex-center bg-black flex w-100 pd-big radius-big">
		<video ref="videoElement" class="pos-absolute pos-t-0 pos-l-0 w-100 video-height" preload autoplay muted loop playsinlineclass playsinline src="/videos/hero.mp4" itemprop="video" type="video/mp4" ></video>

	  <div style="max-width: 40rem" class="bg-white-transp-20 bg-blur-small t-white flex-column pd-big radius-extra o-hidden flex-center flex w-100 h-100 gap-zero">
    	<h2 class="h1 mn-b-semi ">
				{{t('viewpoint.title')}}
	    </h2>
	    <p class="p-medium mn-b-semi ">
	    	{{t('viewpoint.description')}}
	    </p>

      <a :href="t('contacts.addressLink')" target="_blank" rel="noopener" class="button hover-scale-1 t-black bg-white">
        {{ t('contacts.seeOnGoogle') }}
      </a>
	  </div>

	</div>
        
</template>


<script setup>
	/////////////////////////////
	// COMPONENT DEPENDENCIES
	/////////////////////////////
	import { ref, onMounted } from 'vue';
  import init from '@/animations/globals.js';

  import { gsap } from "gsap/dist/gsap";
	import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
	import { useI18n } from 'vue-i18n'
	
	const { t } = useI18n({ 
		useScope: 'global',
		messages: {
		  en:{
		    "viewpoint":{
		      "title":"Viewpoint Terrace & Sea View Bar",
		      "description":"Experience the best of Phuket at The Commune, a stylish bar and terrace located on Karon beach. Enjoy stunning sea views while enjoy refreshing cocktails and taste finest dishes from our menu."
		    }
		  },
		  ru:{
		    "viewpoint":{
		      "title":"Живописная Терраса и Бар с Видом на Море",
		      "description":"Откройте для себя всё лучшее, что может предложить Пхукет, в The Commune, стильном баре и террасе на пляже Карон. Насладитесь впечатляющим видом на море, попивая изысканные коктейли и пробуя превосходные блюда из нашего меню."
		    }
		  },
		  zh:{
		    viewpoint:{
		      "title":"普吉岛海景露台酒吧",
		      "description":"在卡伦海滩的The Commune体验普吉岛的最佳部分。一个时尚的酒吧和露台，您可以一边欣赏海景，一边享受我们的美妙鸡尾酒和菜单上的美味佳肴。"
		    }
		  },
		  fr:{
		    "viewpoint":{
		      "title":"Terrasse et bar avec vue sur mer",
		      "description":"Vivez le meilleur de Phuket à The Commune, un bar et une terrasse chic situés sur la plage de Karon. Admirez la vue imprenable sur la mer en sirotant de savoureux cocktails et en dégustant des plats délicieux de notre menu."
		    }
		  },
		  de:{
		    "viewpoint":{
		      "title":"Terrasse und Bar mit Meerblick",
		      "description":"Erleben Sie das Beste von Phuket in The Commune, einer stilvollen Bar und Terrasse am Karon Beach. Genießen Sie die atemberaubende Aussicht auf das Meer, während Sie köstliche Cocktails trinken und feine Gerichte von unserer Speisekarte kosten."
		    }
		  },
		  it:{
		    "viewpoint":{
		      "title":"Terrazza e bar con vista mare",
		      "description":"Vivi il meglio di Phuket a The Commune, un elegante bar e terrazza situati sulla spiaggia di Karon. Goditi una vista mozzafiato sul mare mentre sorseggi squisiti cocktail e assapori i deliziosi piatti del nostro menu."
		    }
		  }
		}
	})
	/////////////////////////////
	// CREATED
	/////////////////////////////
	gsap.registerPlugin(ScrollTrigger);

	const videoElement = ref(null)

	var isPlaying = false;

	function	checkAndPlayVideo() {
    // Initializing values

		// On video playing toggle values
		videoElement.value.onplaying = function() {
		  isPlaying = true;
		};

		// On video pause toggle values
		videoElement.value.onpause = function() {
		  isPlaying = false;
		};	
  }

  // Play video function
	async function playVid() {      
    if (videoElement.value.paused && !isPlaying) {
      return videoElement.value.play();
    }
	} 
  
	onMounted(() => {
		checkAndPlayVideo()
		playVid()
    init()
	})
</script>

<style lang="scss">
	.video-height {
		  width: 100%;
	    min-height: 100%;
	    max-height: 45vh;
	    object-fit: cover;
	}

	@media screen and (max-width: 1024px) {
		.video-wrapper  {
			position: absolute;
			left: 0;
			top: 0;
			border-radius: 0 !important; 

			.video-gradient {
				position: absolute;
				pointer-events: none;
				top: 7px;
				left: 0;
				width: 100%;
				height: 100%;

				background: linear-gradient(to bottom, transparent, rgba(var(--white),1));
				z-index: 1;
			}
		}

		#viewpoint {
			.cols-2 {
		    .col-1 {
		     	order: 2;
		     	border: 0;
		    }

		    .col-2 {
		      order: 1;
		      min-height: 33vh
		    }
		  }
	  }
	}
</style>


<i18n>

</i18n>